const OrderEditNew = () => import("./views/OrderEditNew.vue");
const PrepaidOrderEdit = () => import("./views/PrepaidOrderEdit.vue");
const Order = () => import("./views/Order.vue");
const Orders = () => import("./views/Orders.vue");
const MealsToRelease = () => import("./views/MealsToRelease.vue");
const NestedMealsToRelease = () => import("./views/NestedMealsToRelease.vue");
const PeriodicReport = () => import("./views/PeriodicReport.vue");
const BulkOrdersReport = () => import("./views/BulkOrdersReport.vue");
const OrdersLabels = () => import("./views/OrdersLabels.vue");
const OrderedMeals = () => import("./views/OrderedMeals.vue");

const route = "/orders";

export default [
  {
    path: route,
    name: "orders.list",
    component: Orders,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: `${route}/create/:orderId?`,
    name: "orders.create",
    component: OrderEditNew,
    props: (route) => ({
      orderId: route.params.orderId ? parseInt(route.params.orderId) : null,
    }),

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_INSTITUTION_WORKER"],
      clarityUpgradeReason: "CreateOrder",
    },
  },

  {
    path: `${route}/createPrepaidOrder`,
    name: "orders.prepaids.create",
    component: PrepaidOrderEdit,
    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
      clarityUpgradeReason: "CreatePrepaidOrder",
    },
  },

  {
    path: `${route}/:orderId`,
    name: "orders.details",
    component: Order,
    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: `${route}/:orderId/edit`,
    name: "orders.edit",
    component: OrderEditNew,
    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTION_WORKER", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:orderId/editPrepaidOrder`,
    name: "orders.prepaids.edit",
    component: PrepaidOrderEdit,
    props: (route) => ({
      orderId: parseInt(route.params.orderId),
    }),

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: "/mealsToRelease",
    name: "orders.mealsToRelease",
    component: MealsToRelease,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },

  {
    path: "/nestedMealsToRelease",
    name: "orders.nestedMealsToRelease",
    component: NestedMealsToRelease,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },

  {
    path: "/periodicReport",
    name: "orders.periodicReport",
    component: PeriodicReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },

  {
    path: "/bulkOrdersReport",
    name: "orders.bulkOrdersReport",
    component: BulkOrdersReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/ordersLabels",
    name: "orders.labels",
    component: OrdersLabels,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/orderedMeals",
    name: "orders.meals",
    component: OrderedMeals,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
